import React from 'react';

import UserList from 'components/users';

const Users = () => <UserList />;

export default Users;
